import { render, staticRenderFns } from "./coderProReviewPage.vue?vue&type=template&id=9d22c83e&scoped=true&"
import script from "./coderProReviewPage.vue?vue&type=script&lang=js&"
export * from "./coderProReviewPage.vue?vue&type=script&lang=js&"
import style0 from "./coderProReviewPage.vue?vue&type=style&index=0&id=9d22c83e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d22c83e",
  null
  
)

export default component.exports